<template>
  <card>
    <h4 slot="header" class="card-title">Edit Profile</h4>
    <form>
      <div class="row">
        <div class="col-md-5">
          <fg-input
            type="text"
            label="Company"
            :disabled="true"
            placeholder="Light dashboard"
            v-model="user.company"
          >
          </fg-input>
        </div>
        <div class="col-md-3">
          <fg-input
            type="text"
            label="Username"
            placeholder="Username"
            v-model="user.username"
          >
          </fg-input>
        </div>
        <div class="col-md-4">
          <fg-input
            type="email"
            label="Email"
            placeholder="Email"
            v-model="user.email"
          >
          </fg-input>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <fg-input
            type="text"
            label="First Name"
            placeholder="First Name"
            v-model="user.firstName"
          >
          </fg-input>
        </div>
        <div class="col-md-6">
          <fg-input
            type="text"
            label="Last Name"
            placeholder="Last Name"
            v-model="user.lastName"
          >
          </fg-input>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <fg-input
            type="text"
            label="Address"
            placeholder="Home Address"
            v-model="user.address"
          >
          </fg-input>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <fg-input
            type="text"
            label="City"
            placeholder="City"
            v-model="user.city"
          >
          </fg-input>
        </div>
        <div class="col-md-4">
          <fg-input
            type="text"
            label="Country"
            placeholder="Country"
            v-model="user.country"
          >
          </fg-input>
        </div>
        <div class="col-md-4">
          <fg-input
            type="number"
            label="Postal Code"
            placeholder="ZIP Code"
            v-model="user.postalCode"
          >
          </fg-input>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>About Me</label>
            <textarea
              rows="5"
              class="form-control border-input"
              placeholder="Here can be your description"
              v-model="user.aboutMe"
            >
            </textarea>
          </div>
        </div>
      </div>
      <div class="text-center">
        <button
          type="submit"
          class="btn btn-info btn-fill float-right"
          @click.prevent="updateProfile"
        >
          Update Profile
        </button>
      </div>
      <div class="clearfix"></div>
    </form>
  </card>
</template>
<script>
import Card from '@/components/UIComponents/Cards/Card.vue';

export default {
  components: {
    Card,
  },
  data() {
    return {
      user: {
        company: 'Light dashboard',
        username: 'michael23',
        email: '',
        firstName: 'Mike',
        lastName: 'Andrew',
        address: 'Melbourne, Australia',
        city: 'melbourne',
        country: 'Australia',
        postalCode: '',
        aboutMe:
          "Lamborghini Mercy, Your chick she so thirsty, I'm in that two seat Lambo.",
      },
    };
  },
  methods: {
    updateProfile() {
      alert(`Your data: ${JSON.stringify(this.user)}`);
    },
  },
};
</script>
<style></style>
